<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <unroll-element
        :title="$t('default_ratio')"
        :available="unrolls_availability.default_ratio_available"
      >
        <brick-generic-modelgenerator-subcomponent-default-ratio
          v-for="metavariables_dict_poid in metavariables_dicts_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="metavariables_dict_poid"
          @is_instantiated="unrolls_availability.default_ratio_available = true"
        />
      </unroll-element>

      <unroll-element
        :title="$t('single_cv')"
        :available="unrolls_availability.single_cv_available"
      >
        <brick-generic-modelgenerator-subcomponent-single-cv
          v-for="training_poid in training_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="training_poid"
          :nb_single_cv_iters="cur_brick.nb_single_cv_iters"
          @is_instantiated="unrolls_availability.single_cv_available = true"
        />
      </unroll-element>

      <unroll-element
        :title="$t('multi_cv')"
        :available="unrolls_availability.full_cv_available"
      >
        <brick-generic-modelgenerator-subcomponent-full-cv
          v-for="training_poid in training_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="training_poid"
          :nb_full_cv_iters="cur_brick.nb_full_cv_iters"
          @is_instantiated="unrolls_availability.full_cv_available = true"
        />
      </unroll-element>

      <unroll-element
        v-if="is_caruana"
        :title="$t('caruana')"
        :available="unrolls_availability.caruana_available"
      >
        <brick-generic-modelgenerator-subcomponent-caruana
          v-for="training_poid in training_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="training_poid"
          :nb_caruana_iters="cur_brick.nb_caruana_iters"
          @is_instantiated="unrolls_availability.caruana_available = true"
        />
      </unroll-element>

      <unroll-element
        v-if="boruta"
        :title="$t('feature_selection')"
        :available="unrolls_availability.boruta_available"
      >
        <brick-generic-modelgenerator-subcomponent-boruta
          v-for="training_poid in training_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="training_poid"
          @is_instantiated="unrolls_availability.boruta_available = true"
        />
      </unroll-element>

      <unroll-element
        :title="$t('roc_curve')"
        :available="unrolls_availability.roc_available"
      >
        <brick-generic-modelgenerator-subcomponent-roc
          v-for="training_poid in training_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="training_poid"
          @is_instantiated="unrolls_availability.roc_available = true"
        />
      </unroll-element>

      <unroll-element
        :title="$t('probability_per_observation')"
        :available="unrolls_availability.probability_available"
      >
        <brick-generic-modelgenerator-subcomponent-probability-chart
          v-for="metavariables_dict_poid in metavariables_dicts_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="metavariables_dict_poid"
          @is_instantiated="unrolls_availability.probability_available = true"
        />
      </unroll-element>

      <unroll-element
        v-if="compute_feature_importance"
        :title="$t('feature_importance')"
        :available="unrolls_availability.feature_importance_available"
      >
        <brick-generic-modelgenerator-subcomponent-feature-importance
          v-for="training_poid in training_poids"
          :brick_id="brick_id"
          :project_id="project_id"
          :metavariables_poid="training_poid"
          @is_instantiated="
            unrolls_availability.feature_importance_available = true
          "
        />
      </unroll-element>

      <b-card :header="$t('model_settings')" class="mt-4">
        <b-form-group>
          <label>
            <b> {{ $t('chosen_table') }} </b>
          </label>
          <b-form-select v-model="table" :options="table_options" />
        </b-form-group>

        <div v-if="table !== -1">
          <select-one-column
            :available_columns="columns"
            :value="targetcolumn"
            @updated_value="targetcolumn = $event"
          >
            <label>
              <b> {{ $t('target_column') }} </b>
            </label>
          </select-one-column>
        </div>

        <b-form-group>
          <label>
            <b> {{ $t('scorer') }} </b>
          </label>
          <b-form-select v-model="scorer" :options="scoreroptions" />
          <div v-if="scorer === 'absolute_threshold'">
            <b-form-group>
              <label>
                <b> {{ $t('chosen_threshold') }} </b>
              </label>
              <b-form-input
                v-model="threshold_choice"
                type="number"
                :placeholder="$t('enter_wanted_threshold')"
              />
            </b-form-group>
          </div>
        </b-form-group>

        <unroll-element :title="$t('advanced_settings')" :available="true">
          <b-form-group>
            <label>
              <b> {{ $t('nb_single_iters') }} </b>
            </label>
            <b-form-input
              v-model="nb_single_cv_iteration"
              type="number"
              :placeholder="$t('enter_number_iterations')"
            />
          </b-form-group>

          <hr />

          <b-form-group>
            <label>
              <b> {{ $t('nb_full_iters') }} </b>
            </label>
            <b-form-input
              v-model="nb_full_cv_iteration"
              type="number"
              :placeholder="$t('enter_number_iterations')"
            />
          </b-form-group>

          <b-form-group>
            <label>
              <b> {{ $t('nb_folds_selection_method') }} </b>
            </label>
            <b-row>
              <b-col offset="1">
                <b-form-radio-group v-model="automatic_nb_folds_chosen" stacked>
                  <b-form-radio :value="true">{{
                    $t('automatic_selection')
                  }}</b-form-radio>
                  <hr />
                  <b-form-radio :value="false">{{
                    $t('manual_selection')
                  }}</b-form-radio>
                  <b-row>
                    <b-col offset="1">
                      <b-form-group :disabled="automatic_nb_folds_chosen">
                        <label>
                          <b> {{ $t('nb_folds') }} </b>
                        </label>
                        <b-form-input
                          v-model="nb_folds_chosen"
                          type="number"
                          :placeholder="$t('enter_number_folds')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-form-group>

          <hr />

          <b-form-group>
            <b> {{ $t('model_combination_or_single_model') }} </b>
            <b-row>
              <b-col offset="1">
                <b-form-radio-group v-model="is_caruana" stacked>
                  <b-form-radio :value="true">{{
                    $t('model_combination')
                  }}</b-form-radio>
                  <b-row>
                    <b-col offset="1">
                      <b-form-group :disabled="!is_caruana">
                        <label>
                          <b>
                            {{ $t('model_combination_automatic_selection') }}
                          </b>
                        </label>

                        <b-row>
                          <b-col offset="1">
                            <b-form-radio-group
                              v-model="automatic_model_selection_chosen"
                              stacked
                            >
                              <b-form-radio :value="true">{{
                                $t('automatic_selection')
                              }}</b-form-radio>
                              <hr />
                              <b-form-group>
                                <b-form-radio :value="false">{{
                                  $t('manual_selection')
                                }}</b-form-radio>
                                <b-form-group
                                  :disabled="automatic_model_selection_chosen"
                                >
                                  <label>
                                    <b> {{ $t('caruana_model_choice') }} </b>
                                  </label>

                                  <b-row>
                                    <b-col offset="1">
                                      <b-form-checkbox-group
                                        v-model="models"
                                        stacked
                                      >
                                        <b-form-checkbox
                                          v-for="model_chosen in caruana_models_choice_options"
                                          :key="model_chosen.value"
                                          :value="model_chosen.value"
                                        >
                                          {{ model_chosen.text }}
                                        </b-form-checkbox>
                                      </b-form-checkbox-group>
                                    </b-col>
                                  </b-row>
                                </b-form-group>
                              </b-form-group>
                            </b-form-radio-group>
                          </b-col>
                        </b-row>

                        <b-form-group>
                          <label>
                            <b>
                              {{ $t('nb_iterations_best_model_search') }}
                            </b>
                            <span
                              v-c-tooltip="$t('nb_iterations_to_choose')"
                              class="fas fa-question-circle"
                            />
                          </label>
                          <b-form-input
                            v-model="nb_caruana_iterations"
                            type="number"
                            :placeholder="$t('enter_number_iterations')"
                          />
                        </b-form-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <hr />

                  <b-form-radio :value="false">{{
                    $t('single_model')
                  }}</b-form-radio>
                  <b-row>
                    <b-col offset="1">
                      <b-form-group :disabled="is_caruana">
                        <label>
                          <b> {{ $t('chosen_model_type') }} </b>
                        </label>
                        <b-form-select
                          v-model="model"
                          :options="model_choice_options"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-form-group>

          <hr />

          <div v-if="table !== -1">
            <columns-choice-options
              v-model="column_id_options"
              :main_text="$t('cols_to_exclude_from_train')"
              :available_column_names="columns"
            >
              <template #sub_component="props">
                <generic-column-name-edition
                  v-bind="props"
                  v-on="props.listeners"
                />
              </template>
            </columns-choice-options>

            <b-form-checkbox
              v-model="same_cv_cols"
              :value="true"
              :unchecked-value="false"
              class="mb-4"
            >
              <b> {{ $t('identical_cross_validation_cols') }} </b>
            </b-form-checkbox>

            <columns-choice-options
              v-if="!same_cv_cols"
              v-model="cv_column_options"
              :main_text="$t('cross_validation_cols_to_choose')"
              :available_column_names="columns"
            >
              <template #sub_component="props">
                <generic-column-name-edition
                  v-bind="props"
                  v-on="props.listeners"
                />
              </template>
            </columns-choice-options>
          </div>

          <hr />

          <b-form-group>
            <label>
              <b>
                {{ $t('name_given_to_result_column') }}
              </b>
            </label>
            <b-form-input
              v-model="decision_colname"
              :placeholder="$t('enter_result_colname')"
            />
          </b-form-group>

          <hr />

          <b-form-group>
            <b-form-checkbox v-model="compute_feature_importance">
              <b> {{ $t('compute_feature_importance') }} </b>
            </b-form-checkbox>
          </b-form-group>

          <hr />

          <b-form-group>
            <b-form-checkbox v-model="boruta">
              <b> {{ $t('automatic_feature_selection') }} </b>
            </b-form-checkbox>
          </b-form-group>

          <div v-if="boruta">
            <b-form-group>
              <label>
                <b>
                  {{ $t('number_importance_tests') }}
                </b>
              </label>
              <b-form-input
                v-model="nb_boruta_iterations"
                type="number"
                :placeholder="$t('enter_number_iterations')"
              />
            </b-form-group>
            <b-form-group>
              <label>
                <b> {{ $t('percentage_trust_importance_tests') }} </b>
              </label>
              <b-form-input
                v-model="boruta_perc"
                type="number"
                :placeholder="$t('enter_confidence_percentage')"
              />
            </b-form-group>
            <b-form-group>
              <label>
                <b>
                  {{ $t('alpha_boruta') }}
                </b>
              </label>
              <b-form-input
                v-model="boruta_alpha"
                type="number"
                step="0.01"
                :placeholder="$t('enter_ratio')"
              />
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="boruta_two_step">
                <b> {{ $t('double_boruta') }} </b>
              </b-form-checkbox>
            </b-form-group>
          </div>
        </unroll-element>
      </b-card>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "default_ratio": "Default Ratio",
    "single_cv": "Model performance estimation (single cross validation)",
    "multi_cv": "Best models robustness estimation (multiple cross validation)",
    "caruana": "Model combination (Caruana iterations)",
    "roc_curve": "ROC curve",
    "probability_per_observation": "Probability per observation",
    "feature_selection": "Feature selection (Boruta)",
    "model_settings": "Model settings",
    "target_column": "Target column:",
    "scorer": "Scorer:",
    "please_choose_a_scorer": "Please choose a scorer",
    "gini": "Gini",
    "absolute_threshold": "Threshold",
    "roc_auc": "ROC AUC (Area under the ROC curve)",
    "advanced_settings": "Advanced settings",

    "column_name": "Column name",
    "importance": "Importance",
    "small_gbdt": "Gradient Boosted Decision Tree (simplified) - [small_gbdt]",
    "gbdt": "Gradient Boosted Decision Tree (full) - [gbdt]",
    "gbdt_forest": "Forest of Gradient Boosted Decision Trees (full) - [gbdt_forest]",
    "random_forest": "Random Forest - [random_forest]",
    "logistic_regression": "Logistic Regression - [logistic_regression]",
    "fm": "Factorization Machines - [fm]",
    "xgboost": "XGBoost - [xgboost]",
    "lightgbm": "LightGBM - [lightgbm]",
    "catboost": "Catboost - [catboost]",
    "pytorch_mlp": "Neural Networks (MLP) - [pytorch_mlp]",
    "naive_bayes_gaussian": "Naive Bayes Gaussian - [naive_bayes_gaussian]",
    "naive_bayes_bernoulli": "Naive Bayes Bernoulli - [naive_bayes_bernoulli]",
    "poly_svc": "Support Vector Classifier with polynomial kernel - [poly_svc]",
    "rbf_svc": "Support Vector Classifier with gaussian kernel - [rbf_svc]",

    "chosen_threshold": "Chosen threshold",
    "enter_wanted_threshold": "Enter wanted threshold",
    "nb_single_iters": "Number of iterations for estimating the models performances",
    "nb_full_iters": "Number of iterations for robust estimation of best found models",
    "nb_folds": "Number of robustness tests (cross validation folds)",
    "enter_number_iterations": "Enter the number of iterations",
    "enter_number_folds": "Enter the number of folds",
    "model_combination_or_single_model": "Combination of models / single model",
    "model_combination": "Combination of models",
    "model_combination_automatic_selection": "Model selection type",
    "single_model": "Single model",
    "chosen_model_type": "Chosen model type",
    "caruana_model_choice": "Choice of models to combine",
    "nb_iterations_to_choose": "Number of iterations to choose",
    "nb_iterations_best_model_search": "Number of iterations to search for best model",
    "cols_to_exclude_from_train": "Columns to remove from training",
    "identical_cross_validation_cols": "Cross validation columns identical to those removed from training ?",
    "cross_validation_cols_to_choose": "Cross validation columns to choose",
    "name_given_to_result_column": "Name given to the result column (default: 'decision')",
    "enter_result_colname": "Enter the name of the result column",
    "compute_feature_importance": "Compute the feature importance",
    "automatic_feature_selection": "Automatic feature selection (Boruta)",
    "number_importance_tests": "Number of feature importance tests",
    "percentage_trust_importance_tests": "Confidence percentage for importance tests",
    "enter_confidence_percentage": "Enter confidence percentage",
    "alpha_boruta": "Alpha parameter (Boruta)",
    "enter_ratio": "Enter the ratio",
    "double_boruta": "Double importance tests (Boruta)",
    "nb_folds_selection_method": "Selection method for the number of cross validation folds",
    "automatic_selection": "Automatic selection",
    "manual_selection": "Manual selection",
    "cwrw_only_one_target_value": "The target contains only one distinct value, the resulting model will be constant"
  },
  "fr": {
    "default_ratio": "Ratio",
    "single_cv": "Estimation de la performance de modèles (validation croisée simple)",
    "multi_cv": "Test de robustesse des meilleurs modèles trouvés (validation croisée multiple)",
    "caruana": " Combinaison de modèles (itérations Caruana)",
    "roc_curve": "Courbe ROC",
    "probability_per_observation": "Probabilité par observation",
    "feature_selection": "Sélection de features (Boruta)",
    "model_settings": "Paramétrage du modèle",
    "target_column": "Colonne à prédire",
    "scorer": "Critère de score :",
    "please_choose_a_scorer": "Veuillez choisir un critère de score",
    "gini": "Gini",
    "absolute_threshold": "Seuil",
    "roc_auc": "ROC AUC (Area under the ROC curve)",
    "advanced_settings": "Choix des options avancées",

    "column_name": "Nom de la colonne",
    "importance": "Importance",
    "small_gbdt": "Arbre de gradient boosté (simplifié) - [small_gbdt]",
    "gbdt": "Arbre de gradient boosté (complet) - [gbdt]",
    "gbdt_forest": "Forêt d'arbres de gradient boosté (complets) - [gbdt_forest]",
    "random_forest": "Forêt aléatoire - [random_forest]",
    "logistic_regression": "Régression logistique - [logistic_regression]",
    "fm": "Machine à factorisation - [fm]",
    "xgboost": "XGBoost - [xgboost]",
    "lightgbm": "LightGBM - [lightgbm]",
    "catboost": "Catboost - [catboost]",
    "pytorch_mlp": "Réseaux de neurones (MLP) - [pytorch_mlp]",
    "naive_bayes_gaussian": "Bayésien Naïf Gaussien - [naive_bayes_gaussian]",
    "naive_bayes_bernoulli": "Bayésien Naïf Bernoulli - [naive_bayes_bernoulli]",
    "poly_svc": "Classifieur à vecteurs de support avec noyau polynomial - [poly_svc]",
    "rbf_svc": "Classifieur à vecteurs de support avec noyau gaussien - [rbf_svc]",

    "chosen_threshold": "Seuil choisi",
    "enter_wanted_threshold": "Entrez le seuil voulu",
    "nb_single_iters": "Nombre d'itérations d'estimation de la performance de modèles",
    "nb_full_iters": "Nombre d'itérations du test de robustesse des meilleurs modèles trouvés",
    "nb_folds": "Nombre de tests de robustesse (folds de validation croisée)",
    "enter_number_iterations": "Entrez le nombre d'itérations",
    "enter_number_folds": "Enter le nombre de folds",
    "model_combination_or_single_model": "Combinaison de modèles / modèle simple",
    "model_combination": "Combinaison de modèles",
    "model_combination_automatic_selection": "Type de sélection de modèle",
    "single_model": "Modèle simple",
    "chosen_model_type": "Type de modèle choisi",
    "caruana_model_choice": "Choix des modèles à combiner",
    "nb_iterations_to_choose": "Nombre d'itérations à choisir",
    "nb_iterations_best_model_search": "Nombre d'itérations de recherche du meilleur modèle",
    "cols_to_exclude_from_train": "Colonnes à exclure de l'entraînement :",
    "identical_cross_validation_cols": "Colonnes de validation croisée identiques à celles exclues de l'entraînement",
    "cross_validation_cols_to_choose": "Colonnes de validation croisée à choisir",
    "name_given_to_result_column": "Nom donné à la colonne résultat (par défaut 'decision')",
    "enter_result_colname": "Entrez le nom de la colonne résultat",
    "compute_feature_importance": "Calcul de l'importance des features",
    "automatic_feature_selection": "Sélection automatique des features (Boruta)",
    "number_importance_tests": "Nombre de tests d'importance des features :",
    "percentage_trust_importance_tests": "Pourcentage de confiance pour les tests d'importance :",
    "enter_confidence_percentage": "Entrez le pourcentage de confiance",
    "alpha_boruta": "Paramètre alpha (Boruta) :",
    "enter_ratio": "Entrez le ratio",
    "double_boruta": "Double tests d'importance (Boruta)",
    "nb_folds_selection_method": "Méthode de sélection du nombre de folds de validation croisée",
    "automatic_selection": "Sélection automatique",
    "manual_selection": "Sélection manuelle",
    "cwrw_only_one_target_value": "La colonne target ne contient qu'une valeur disctincte, le modèle résultant sera constant"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { table_columns } from '@/api/subscriptions.js'
import {
  FrozenSet,
  Dict,
  FrozenDict,
  BasicTableInfoEntity,
} from '@/components/object_model.js'
import { round_value } from '@/utils.js'

import { global_brick_mixin } from '@/components/mixin.js'
import UnrollElement from './unroll_element.vue'
import ColumnsChoiceOptions from './columns_choice_options.vue'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import SelectOneColumn from './select_one_column.vue'

import BrickGenericModelgeneratorSubcomponentDefaultRatio from './brick_generic_modelgenerator_subcomponent_default_ratio.vue'
import BrickGenericModelgeneratorSubcomponentSingleCv from './brick_generic_modelgenerator_subcomponent_single_cv.vue'
import BrickGenericModelgeneratorSubcomponentFullCv from './brick_generic_modelgenerator_subcomponent_full_cv.vue'
import BrickGenericModelgeneratorSubcomponentCaruana from './brick_generic_modelgenerator_subcomponent_caruana.vue'
import BrickGenericModelgeneratorSubcomponentBoruta from './brick_generic_modelgenerator_subcomponent_boruta.vue'
import BrickGenericModelgeneratorSubcomponentRoc from './brick_generic_modelgenerator_subcomponent_roc.vue'
import BrickGenericModelgeneratorSubcomponentProbabilityChart from './brick_generic_modelgenerator_subcomponent_probability_chart.vue'
import BrickGenericModelgeneratorSubcomponentFeatureImportance from './brick_generic_modelgenerator_subcomponent_feature_importance.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgenerator',
  components: {
    ColumnsChoiceOptions,
    UnrollElement,
    GenericColumnNameEdition,
    SelectOneColumn,
    Chart,

    BrickGenericModelgeneratorSubcomponentDefaultRatio,
    BrickGenericModelgeneratorSubcomponentSingleCv,
    BrickGenericModelgeneratorSubcomponentFullCv,
    BrickGenericModelgeneratorSubcomponentCaruana,
    BrickGenericModelgeneratorSubcomponentBoruta,
    BrickGenericModelgeneratorSubcomponentRoc,
    BrickGenericModelgeneratorSubcomponentProbabilityChart,
    BrickGenericModelgeneratorSubcomponentFeatureImportance,
  },
  mixins: [global_brick_mixin],
  data() {
    return {
      table: -1,
      targetcolumn: null,

      column_id_options: [],
      cv_column_options: [],

      same_cv_cols: true,

      columns: [],

      is_caruana: null,
      compute_feature_importance: true,
      boruta: true,

      scorer: null,
      decision_colname: '',
      model: null,
      models: [],
      scoreroptions: [
        { value: null, text: this.$t('please_choose_a_scorer') },
        { value: 'gini', text: this.$t('gini') },
        { value: 'absolute_threshold', text: this.$t('absolute_threshold') },
        { value: 'roc_auc', text: this.$t('roc_auc') },
      ],
      threshold_choice: null,
      nb_single_cv_iteration: null,
      nb_full_cv_iteration: null,
      nb_caruana_iterations: null,
      nb_folds_chosen: null,
      automatic_nb_folds_chosen: null,
      automatic_model_selection_chosen: null,
      has_been_updated: false,

      unrolls_availability: {
        default_ratio_available: false,
        single_cv_available: false,
        full_cv_available: false,
        caruana_available: false,
        boruta_available: false,
        roc_available: false,
        probability_available: false,
        feature_importance_available: false,
      },

      nb_boruta_iterations: null,
      boruta_perc: null,
      boruta_alpha: null,
      boruta_two_step: null,
      boruta_seed: null,

      roc_data: [],
      single_cv: null,
      full_cv: null,
    }
  },
  computed: {
    _() {
      return _
    },
    training_poids() {
      // console.log(
      //   'training_poids',
      //   JSON.stringify(this.metavariables_dicts_poids)
      // )
      // console.log(JSON.stringify(this.available_metavariables_dicts))
      let res = _.filter(
        this.metavariables_dicts_poids,
        elt => this.available_metavariables_dicts[elt]['is_training'] === true
      )

      return res
    },

    adapted_data() {
      let scorer = this.scorer
      let is_scorer_threshold = this.scorer === 'absolute_threshold'
      if (is_scorer_threshold) {
        scorer = `${this.scorer}(${this.threshold_choice})`
      }

      let cv_columns
      if (this.same_cv_cols) {
        cv_columns = this.column_id_options
      } else {
        cv_columns = this.cv_column_options
      }

      // TODO : Use Lodash motherfucker
      let models_in_correct_order = []

      for (let model_options of this.model_choice_base_options) {
        let model_name = model_options.value
        if (_.includes(this.models, model_name)) {
          models_in_correct_order.push(model_name)
        }
      }
      let checked_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        checked_table_id = [parent_info_entity_type]
      }
      // N.B PL : Why the special case (like in historyfe)
      if (this.table == this.effective_table_id) {
        checked_table_id = this.cur_brick.parents_info
      }
      // If we had more than one table in entry
      // if (this.cur_brick.table_id.length > 1) {
      //   // And we haven't changed the table from brick edition
      //   if (this.table === [-1] || this.table === []) {
      //     // We try to show that there are no differences in adapted data
      //     checked_table_id = this.cur_brick.table_id
      //   }
      // }

      let adapted = {
        uid: this.brick_id,
        parents_info: checked_table_id,
        target_column: this.targetcolumn,
        index_columns: this.column_id_options,
        cv_columns: cv_columns,
        decision_colname: this.decision_colname,
        model: this.model,
        scorer,
        is_caruana: this.is_caruana,
        models: models_in_correct_order,
        compute_feature_importance: this.compute_feature_importance,
        boruta: this.boruta,
        boruta_two_step: this.boruta_two_step,
      }

      _.assignIn(adapted, this.description_name)

      // TODO : Que se passe-t-il si l'utilisateur
      // a rempli les champs puis décoché la case
      adapted.nb_single_cv_iters = parseInt(this.nb_single_cv_iteration, 10)
      adapted.nb_full_cv_iters = parseInt(this.nb_full_cv_iteration, 10)
      adapted.nb_folds = parseInt(this.nb_folds_chosen, 10)
      adapted.automatic_nb_folds = this.automatic_nb_folds_chosen
      adapted.automatic_model_selection = this.automatic_model_selection_chosen
      adapted.nb_caruana_iters = parseInt(this.nb_caruana_iterations, 10)
      adapted.nb_boruta_iterations = parseInt(this.nb_boruta_iterations, 10)
      adapted.boruta_perc = parseInt(this.boruta_perc, 10)
      adapted.boruta_alpha = parseFloat(this.boruta_alpha)

      return adapted
    },

    effective_table_id() {
      // Effective because when multiple tables, returns -1
      // N.B PL : Why is this not everywhere in table with unique parents
      let table_id = this.cur_brick.parents_info || []
      let res = -1
      if (table_id.length === 1) {
        res = table_id[0].uid
      }
      return res
    },

    model_choice_base_options() {
      let res = [
        {
          value: 'small_gbdt',
          text: this.$t('small_gbdt'),
          nb_single_iters: 30,
          nb_full_iters: 10,
        },
        {
          value: 'gbdt',
          text: this.$t('gbdt'),
          nb_single_iters: 30,
          nb_full_iters: 10,
        },
        {
          value: 'gbdt_forest',
          text: this.$t('gbdt_forest'),
          nb_single_iters: 60,
          nb_full_iters: 20,
        },
        {
          value: 'random_forest',
          text: this.$t('random_forest'),
          nb_single_iters: 30,
          nb_full_iters: 10,
        },
        {
          value: 'logistic_regression',
          text: this.$t('logistic_regression'),
          nb_single_iters: 20,
          nb_full_iters: 10,
        },
        {
          value: 'fm',
          text: this.$t('fm'),
          nb_single_iters: 40,
          nb_full_iters: 15,
        },
        {
          value: 'xgboost',
          text: this.$t('xgboost'),
          nb_single_iters: 60,
          nb_full_iters: 20,
        },
        {
          value: 'lightgbm',
          text: this.$t('lightgbm'),
          nb_single_iters: 60,
          nb_full_iters: 20,
        },
        {
          value: 'catboost',
          text: this.$t('catboost'),
          nb_single_iters: 60,
          nb_full_iters: 20,
        },
        {
          value: 'pytorch_mlp',
          text: this.$t('pytorch_mlp'),
          nb_single_iters: 60,
          nb_full_iters: 20,
        },
        {
          value: 'naive_bayes_gaussian',
          text: this.$t('naive_bayes_gaussian'),
          nb_single_iters: 1,
          nb_full_iters: 1,
        },
        {
          value: 'naive_bayes_bernoulli',
          text: this.$t('naive_bayes_bernoulli'),
          nb_single_iters: 1,
          nb_full_iters: 1,
        },
        {
          value: 'poly_svc',
          text: this.$t('poly_svc'),
          nb_single_iters: 30,
          nb_full_iters: 10,
        },
        {
          value: 'rbf_svc',
          text: this.$t('rbf_svc'),
          nb_single_iters: 10,
          nb_full_iters: 5,
        },
      ]
      return res
    },

    model_choice_options() {
      let res = this.model_choice_base_options
      return res
    },

    caruana_models_choice_options() {
      let res = this.model_choice_base_options
      return res
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        // If it has, then update the current table displayed

        // And check if target/index columns have already been chosen
        this.column_id_options = new_val.index_columns

        if (new_val.cv_columns === new_val.index_columns) {
          this.same_cv_cols = true
          this.cv_column_options = []
        } else {
          this.cv_column_options = new_val.cv_columns
        }

        // as well as scorer
        let cur_scorer = new_val.scorer
        // Little ugly patch instead of cleaner regex ?

        if (!_.isNull(cur_scorer)) {
          let regexp = new RegExp('(absolute_threshold)\\((\\d*)\\)')
          let scorer_regexp = cur_scorer.match(regexp)
          if (scorer_regexp !== null) {
            this.scorer = scorer_regexp[1]
            this.threshold_choice = scorer_regexp[2]
          } else {
            this.scorer = cur_scorer
          }
        }

        this.table = this.effective_table_id

        this.targetcolumn = new_val.target_column

        this.is_caruana = new_val.is_caruana
        this.decision_colname = new_val.decision_colname
        this.model = new_val.model
        this.nb_single_cv_iteration = new_val.nb_single_cv_iters
        this.nb_full_cv_iteration = new_val.nb_full_cv_iters
        this.nb_folds_chosen = new_val.nb_folds
        this.automatic_nb_folds_chosen = new_val.automatic_nb_folds
        this.automatic_model_selection_chosen =
          new_val.automatic_model_selection
        this.models = new_val.models
        this.nb_caruana_iterations = new_val.nb_caruana_iters

        this.compute_feature_importance = new_val.compute_feature_importance

        this.boruta = new_val.boruta
        this.nb_boruta_iterations = new_val.nb_boruta_iterations
        this.boruta_perc = new_val.boruta_perc
        this.boruta_alpha = new_val.boruta_alpha
        this.boruta_two_step = new_val.boruta_two_step
        this.boruta_seed = new_val.boruta_seed
      },
    },
    table: {
      immediate: true,
      async handler(newTableId) {
        if (this.bricks_undeleted) {
          if (
            !_.isUndefined(this.table) &&
            !_.isNull(this.table) &&
            this.table !== -1 &&
            this.bricks_undeleted['bricks'][this.table]
          ) {
            let res = await table_columns(
              this.project_id,
              this.bricks_undeleted['bricks'][this.table].uid
            )

            this.columns = res['pipe_object'] || []
          }
        }
      },
    },
    caruana_single_cv(new_val) {
      this.single_cv = new_val
    },
    caruana_full_cv(new_val) {
      this.full_cv = new_val
    },
  },
}
</script>
